import React, { useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { NewsList } from "../Data/NewsList";
import Section from "../components/Section";
import { delayNavigation } from "../helpers/helpers";
import { useDispatch } from "react-redux";

const NewsDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mediaData = useMemo(() => {
    const splittedPathName = location.pathname.split("/");
    const mediaName = NewsList.find(
      (news) => news.pathName === splittedPathName[splittedPathName.length - 1]
    );
    return mediaName;
  }, [location.pathname]);

  return (
    <Section bg={"bg-inherit"}>
      <div className="col-span-full pt-40 grid grid-cols-12 ">
        <div className="col-span-10 col-start-2 xl:col-span-8 xl:col-start-3 flex flex-col items-start justify-start gap-y-6 text-primary-bg-blue tracking-wider">
          <span className="text-primary-orange text-lg font-semibold">
            {mediaData.type}
          </span>
          <strong className="text-2xl xl:text-4xl font-bold leading-snug">
            {mediaData.header}
          </strong>
          <span className="text-xs xl:text-sm font-semibold ">
            გამოქვეყნების თარიღი: {mediaData.date}
          </span>
        </div>
        {mediaData.id === 1 && (
          <div className="col-span-10 col-start-2 xl:col-span-8 xl:col-start-3 flex flex-col xl:flex-row items-center justify-between gap-6 py-32 text-2xl text-primary-bg-blue/90 tracking-wider font-semibold leading-relaxed ">
            <div className="w-full xl:w-1/2 h-96 flex items-start justify-center ">
              <img
                src={mediaData.img}
                alt="news"
                className="w-full h-full xl:w-4/5 object-cover"
              />
            </div>
            <div
              className="w-full xl:w-1/2"
              dangerouslySetInnerHTML={{ __html: mediaData?.text }}
            />
          </div>
        )}
        {mediaData.id === 2 && (
          <div className="col-span-10 col-start-2 xl:col-span-8 xl:col-start-3 flex flex-col items-center justify-between gap-6 py-32 text-primary-bg-blue/90 tracking-wider font-semibold leading-relaxed ">
            <div className="w-full h-96 flex items-start justify-center">
              <img
                src={mediaData.img}
                alt="news"
                className="w-full h-full object-cover"
              />
            </div>
            <div
              className="w-full "
              dangerouslySetInnerHTML={{ __html: mediaData?.text }}
            />
            <div className="w-full xl:h-96 block xl:flex items-start justify-start gap-4 ">
              <img
                src={mediaData.imggiorgi}
                alt="news"
                className="w-full h-auto xl:w-2/5 object-cover"
              />
              <div
                className="w-full xl:w-3/5 mt-4 xl:mt-0"
                dangerouslySetInnerHTML={{ __html: mediaData?.text2 }}
              />
            </div>
            <a
              href={mediaData.link}
              target="_blank"
              rel="noreferrer"
              className="italic cursor-pointer text-primary-orange place-self-start"
            >
              იხილეთ სტატია სრულად ...{" "}
            </a>
          </div>
        )}
        <div className="col-span-6 col-start-4 xl:col-span-2 xl:col-start-8 text-sm xl:text-xl font-semibold tracking-widest text-primary-bg-blue mb-16">
          <div className="relative group max-w-max place-self-end">
            <Link
              to={"/news"}
              onClick={(event) => {
                delayNavigation(dispatch, navigate, `/news`, event);
              }}
            >
              ყველა სიახლე
            </Link>
            <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default NewsDetails;
